import { Box } from '@mui/material';

export type RibbonToastAutoCloseBarProps = {
  /** Duration of the shrink animation; should match toast autoClose. */
  durationMs: number;
};

/**
 * Neutral auto-close progress track rendered inside the toast Paper bottom edge.
 */
export function RibbonToastAutoCloseBar({ durationMs }: RibbonToastAutoCloseBarProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 3,
        bgcolor: 'grey.100',
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          bgcolor: 'grey.300',
          transformOrigin: 'left',
          animation: `ribbonToastAutoClose ${durationMs}ms linear forwards`,
          '@keyframes ribbonToastAutoClose': {
            from: { transform: 'scaleX(1)' },
            to: { transform: 'scaleX(0)' },
          },
        }}
      />
    </Box>
  );
}
